<template>
  <dv-scroll-ranking-board
    :config="config"
    style="width: 100%; height: 300px"
  />
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>

</style>